// @ts-expect-error moduleResolution:nodenext issue 54523
import { html, LitElement, nothing } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import LightElement from './light-element.js';
import { IPrice } from '../models/IPrice.js';

@customElement('product-main-price')
export default class ProductMainPrice extends LightElement {

	@property({ type: Boolean })
	hideRrp: boolean;

	@property({ type: Boolean })
	isTradeCustomer: boolean;

	@property({ type: Boolean })
	showSaleWasPrice: boolean;

	@property({ type: Object })
	rrp: IPrice;

	@property({ type: Object })
	retailPrice: IPrice;

	@property({ type: Object })
	originalPrice: IPrice;

	@property({ type: Boolean })
	hasVariants: boolean;

	@property({ type: Object })
	price: IPrice;

	@property({ type: Boolean })
	variantIsSelected = false;

	@property({ type: String })
	percentageSaving: string;

	@property({ type: String })
	tradeSaving: string;

	connectedCallback() {
		super.connectedCallback();
		this.classList.add('has-loaded');
	}

	render() {

		return html`

		<div class="c-product-main-price ${this.isTradeCustomer ? "c-product-main-price--trade" : ""}" data-test="product-main-price-block">
			${this.isTradeCustomer ?
			html`
				<span class="c-price__intro c-product-main-price__intro js-product-price-intro ${this.showSaleWasPrice ? "c-price__intro--sale" : ""}">Your trade price</span>

					<p id="productPrice" class="c-product-main-price__main ${this.showSaleWasPrice ? "c-product-main-price__main--sale" : ""}" data-base-original-price="${this.originalPrice.Price.toFixed(2)}" data-base-on-sale="true" data-base-price="${this.price.Price.toFixed(2)}" data-base-rrp="${this.rrp.Price.toFixed(2) }" data-test="product-price">
						${this.hasVariants && !this.variantIsSelected ?
							html`<span class="c-product-main-price__main__from" data-test="product-price-from">From</span>` : nothing
						}
						<span data-test="split-price" class="c-product-main-price__main__split__price">${unsafeHTML(this.price.Formatted)}</span>
						<span class="c-product-main-price__main__suffix">inc. VAT</span>
					</p>

					<p class="c-product-main-price__rrp">
						Retail <span id="productRetailPrice" data-test="product-retail-price" class="js-product-retail-price">${unsafeHTML(this.retailPrice.Formatted)}</span>
						<span class="c-product-main-price__main__was__container js-product-was-container ${!this.showSaleWasPrice ? "u-hide" : ""}">Was <span data-test="product-price-was" class="c-product-main-price__main__was js-product-was-price">${unsafeHTML(this.originalPrice.Formatted)}</span></span>
						${this.percentageSaving ?
							html`<span class="c-product-main-price__rrp__save" data-test="product-price-saving-wrapper">save <span id="productSave" data-test="product-price-saving" class="js-product-trade-saving">${this.tradeSaving}</span></span>`
						: nothing}
					</p>
				`
				:
			html`
			${!this.hideRrp ? 
				html`
					<p class="c-product-main-price__rrp">
						<a href="#tooltip-rrp" class="js-tooltip-trigger js-tooltip-trigger--small" data-js-tooltip-trigger data-test="product-price-tooltip-trigger"><tooltip-trigger-icon></tooltip-trigger-icon><span class="u-visuallyhidden">More information</span></a> <abbr title="Recommended Retail Price">RRP</abbr> <span id="productRRP" data-test="product-price-rrp" class="js-product-rrp">£${Math.trunc(this.rrp.Price)}</span>
						${this.percentageSaving ?
							html`<span class= "c-product-main-price__rrp__save" data-test="product-price-saving-wrapper">save <span id="productSave" data-test="product-price-saving" class="js-product-retail-saving">${this.percentageSaving}</span>%</span>`
						: nothing}
					</p>
				`
				: nothing
			}

			${this.showSaleWasPrice ?
				html`
					<p id="productPrice" class="c-product-main-price__main c-product-main-price__main--sale" data-base-original-price="${this.originalPrice.Price.toFixed(2)}" data-base-on-sale="true" data-base-price="${this.price.Price.toFixed(2)}" data-base-rrp="${this.rrp.Price.toFixed(2) }" data-test="product-price">
						${this.hasVariants && !this.variantIsSelected ?
						html`<span class="c-product-main-price__main__from" data-test="product-price-from">From</span>` : nothing
					}
						<span data-test="split-price" class="c-product-main-price__main__split__price">${unsafeHTML(this.price.Formatted)}</span>
						<span class="u-visuallyhidden">was </span><span class="c-product-main-price__main__was" data-test="product-price-was">${unsafeHTML(this.originalPrice.Formatted)}</span>
					</p>
				` :
				html`
					<p id="productPrice" class="c-product-main-price__main" data-base-original-price="${this.originalPrice.Price}" data-base-on-sale="false" data-base-price="${this.price.Price.toFixed(2)}" data-base-rrp="${this.rrp.Price.toFixed(2) }" data-test="product-price">
						${this.hasVariants && !this.variantIsSelected ?
							html`<span class="c-product-main-price__main__from" data-test="product-price-from">From</span>` : nothing
					}
						<span data-test="split-price" class="c-product-main-price__main__main">${unsafeHTML(this.price.Formatted)}</span>
					</p>
				`}
			`
			}
		</div>
		`;

	}

}
